import api from "./api";

/**
 * The business dashboard home (spec 07). The layout and every widget come
 * from the server, computed by the reports engine; the page only draws them.
 */

/** Dashboard filters -> query params (branches as "a,b"); empties dropped. */
const toParams = (filters = {}) => {
  const params = { ...filters };

  if (Array.isArray(params.branches)) params.branches = params.branches.join(",");

  Object.keys(params).forEach((key) => {
    if (params[key] === "" || params[key] === null || params[key] === undefined) delete params[key];
  });

  return params;
};

/** GET /business/dashboard — the reader's variant and widget list. */
export const fetchDashboard = async () => {
  const { data } = await api.get("/business/dashboard");

  return data.data;
};

/** GET /business/dashboard/widgets/{key} — one widget, loaded on its own. */
export const fetchDashboardWidget = async (key, filters = {}) => {
  const { data } = await api.get(`/business/dashboard/widgets/${key}`, { params: toParams(filters) });

  return data.data;
};

/** POST /business/dashboard/export — xlsx downloads; pdf opens a print page. */
export const exportDashboard = async (format, filters = {}) => {
  const response = await api.post(
    "/business/dashboard/export",
    { format, filters: toParams(filters) },
    { responseType: "blob" }
  );

  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: response.headers["content-type"] })
  );

  if (format === "pdf") {
    window.open(url, "_blank", "noopener");
  } else {
    const disposition = response.headers["content-disposition"] ?? "";
    const match = /filename="?([^"]+)"?/.exec(disposition);
    const link = document.createElement("a");
    link.href = url;
    link.download = match ? match[1] : `dashboard.${format}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};
